import classNames from 'classnames';
import { CSSProperties, MouseEvent, ReactNode } from 'react';
import { LinkInfo } from '../../types';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import LinkInfoRenderer from '../LinkInfoRenderer';
import styles from './styles/styles.module.scss';

type LinkButtonOrDivProps = {
  children: ReactNode;
  className?: string;
  'data-denali'?: string;
  linkInfo?: LinkInfo;
  onClick?: (e?: MouseEvent<HTMLElement>) => void;
  onContextMenu?: (e: MouseEvent<HTMLElement>) => void;
  onMouseEnter?: (e: MouseEvent<HTMLElement>) => void;
  onMouseLeave?: (e: MouseEvent<HTMLElement>) => void;
  stopPropagation?: boolean;
  style?: CSSProperties;
};

// Used to render a basic link, button, or div wrapper, depending on the values of linkInfo and onClick
const LinkButtonOrDiv = ({
  children,
  className,
  'data-denali': dataDenali,
  linkInfo,
  onClick,
  onContextMenu,
  onMouseEnter,
  onMouseLeave,
  stopPropagation = false,
  style
}: LinkButtonOrDivProps) => {
  const classes = classNames(className, styles.container);

  const onElementClick = (e: MouseEvent<HTMLElement>) => {
    if (stopPropagation) {
      e.stopPropagation();
    }
    if (onClick) {
      onClick(e);
    }
  };

  if (linkInfo) {
    return (
      <LinkInfoRenderer
        className={classes}
        {...setDenaliAttribute(dataDenali || 'LinkButtonOrDiv')}
        linkInfo={linkInfo}
        onClick={onElementClick}
        onContextMenu={onContextMenu}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={style}
      >
        {children}
      </LinkInfoRenderer>
    );
  }

  if (onClick) {
    return (
      <button
        className={classes}
        {...setDenaliAttribute(dataDenali || 'LinkButtonOrDiv')}
        onClick={onElementClick}
        onContextMenu={onContextMenu}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={style}
        type="button"
      >
        {children}
      </button>
    );
  }

  return (
    <span
      className={classes}
      {...setDenaliAttribute(dataDenali || 'LinkButtonOrDiv')}
      onContextMenu={onContextMenu}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={style}
    >
      {children}
    </span>
  );
};

export default LinkButtonOrDiv;
